<div class="flex flex-col w-full">
  <label *ngIf="label" class="text-[12px] font-medium text-corporate-3 mb-1 block">
    {{label}}<span *ngIf="required" class="text-error font-bold ml-0.5"> *</span>
  </label>

  <div class="relative flex items-center w-full" *ngIf="!multiline">
    <input
      [id]="id || null"
      [name]="name || null"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [maxlength]="maxlength || null"
      [(ngModel)]="innerValue"
      (ngModelChange)="onInput($event)"
      (change)="onChangeEmit($event)"
      (focus)="onFocusEmit($event)"
      (blur)="onBlurEmit($event)"
      class="app-input-field w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate disabled:bg-[#f4f6f9] disabled:opacity-70 disabled:cursor-not-allowed"
    />
    <button
      *ngIf="icon"
      type="button"
      (click)="onIconClick($event)"
      class="absolute right-2 flex items-center justify-center w-9 h-9 rounded-lg text-corporate-3 border border-[#d4dde6] bg-transparent cursor-pointer transition-all hover:bg-hover-2 hover:border-corporate hover:text-corporate"
    >
      <lucide-icon [name]="icon" [size]="18"></lucide-icon>
    </button>
  </div>

  <textarea
    *ngIf="multiline"
    [id]="id || null"
    [name]="name || null"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [maxlength]="maxlength || null"
    [(ngModel)]="innerValue"
    (ngModelChange)="onInput($event)"
    (change)="onChangeEmit($event)"
    (focus)="onFocusEmit($event)"
    (blur)="onBlurEmit($event)"
    class="app-input-field w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate disabled:bg-[#f4f6f9] disabled:opacity-70 disabled:cursor-not-allowed resize-none"
    rows="1"
  ></textarea>
</div>